const roleTranslations: { [key: string]: string } = {
  fp_subsidiesysteemgebruiker: 'Functieprofiel subsidiesysteemgebruiker',
  fp_sturingsmiddelen: 'Functieprofiel sturingsmiddelen',
  fp_wonen: 'Functieprofiel wonen',
  fp_verkeerhandhaver: 'Functieprofiel verkeerhandhaver',
  fp_documentscanner: 'Functieprofiel documentscanner',
  fp_mdw: 'Functieprofiel Medewerker',
  fp_wagenpark: 'Functieprofiel wagenpark',
  fp_burger: 'Functieprofiel burger',
  fp_ondermijningonderzoeker: 'Functieprofiel ondermijningonderzoeker',
  fp_zaaksysteemgebruiker: 'Functieprofiel wonen zaaksystem voor de BRP-proxy-API',
  brp_r: 'Basis Register Personen/Leesrechten',
  bd_r: 'Bouwdossiers/Beperkte rechten Bouwdossiers',
  bd_x: 'Bouwdossiers/Extra rechten Bouwdossiers',
  wkpb_rbdu: 'Wet Kenbaarheid Publiekrechtelijke Beperkingen/Lezen URL Brondocument',
  cat_r:
    'Catalogus/Redacteur catalogus- Kan een dataset aanmaken en wijzigen, maar niet beschikbaar maken',
  cat_w:
    'Catalogus/Beheer catalogus. Kan een dataset aanmaken en wijzigen, en ook beschikbaar maken',
  brk_ro: 'Kadaster: Lezen van Kadastrale Objecten',
  hr_r: 'Handelsregister: Raadplegen. We hebben een overeenkomst met de KvK dat onze afslag van het handelsregister alleen door ambtenaren te raadplegen is.',
  brk_rsn: 'Kadaster: Lezen van kadastrale objecten en natuurlijke subjecten.',
  brk_rs: 'Kadaster: Lezen van kadastrale objecten en niet-natuurlijke subjecten.',
  bsk_eigendom: 'Basisstatistiek/Lezen van eigendomsverhouding en type eigenaar verblijfsobjecten',
  mon_rdm: 'Monumenten: Lezen details van monumenten.',
  mon_rbc: 'Monumenten: Lezen beschrijvingen van complexen.',
  tlls_r: 'Tellus/Leesrechten',
}

const getRole = (code: string): string => roleTranslations[code]

export default getRole
